<script setup lang="ts">
import { DrawerViewType, useDrawerStore } from "@/stores";
import { mdiMap } from "@mdi/js";
import { useScreenSize } from "@soft-db/ui";
import { MapItemType } from "../map/use/use-marker-manager";
import NavButton from "./NavButton.vue";

const props = defineProps<{
	sourceType: MapItemType;
	sourceId: string;
	inFavorite: boolean;
	disabled?: boolean;
	disabledReason?: string;
}>();

const { t } = useI18n();
const { mdOrLower } = useScreenSize();

const drawer = useDrawerStore();

function clickHandler() {
	if (!props.inFavorite && drawer.view === DrawerViewType.FAVORITES) {
		drawer.toAll();
	}
}
</script>

<template>
	<NavButton
		:title="t('common.map')"
		:icon="mdiMap"
		:to="{
			name: 'map',
			query: { id: sourceId, type: sourceType },
		}"
		color="success"
		:size="mdOrLower ? 'lg' : 'sm'"
		:disabled="disabled"
		:disabledReason="disabledReason"
		@click="clickHandler"
	/>
</template>
